import { getUniqueString as u } from "../../common/utils/index.js";
import { createApp as m, h as s, getCurrentInstance as f } from "vue";
import v from "deep-equal";
import n from "../tooltip/tooltip.js";
import { TOOLTIP_DIRECTIONS as T } from "../tooltip/tooltip-constants.js";
const k = {
  name: "dt-tooltip-directive",
  install(d) {
    const r = "top";
    if (!globalThis.__DtTooltipDirectiveAppInstance) {
      const o = m({
        name: "DtTooltipDirectiveApp",
        components: { DtTooltip: n },
        data() {
          return {
            tooltips: []
          };
        },
        created() {
          globalThis.__DtTooltipDirectiveAppInstance = f();
        },
        methods: {
          addOrUpdateTooltip(i, e) {
            const l = this.tooltips.findIndex((c) => c.id === i);
            l !== -1 ? this.tooltips.splice(l, 1, { id: i, ...e }) : this.tooltips.push({ id: i, ...e });
          },
          removeTooltip(i) {
            this.tooltips = this.tooltips.filter((e) => e.id !== i);
          }
        },
        render() {
          return s(
            "div",
            this.tooltips.map(({ id: i, ...e }) => s(n, {
              key: i,
              ...e,
              sticky: e.sticky !== void 0 ? e.sticky : !0,
              /**
               * Set the delay to false when running tests only.
               */
              delay: e.delay !== void 0 ? e.delay : process.env.NODE_ENV !== "test",
              externalAnchor: `[data-dt-tooltip-id="${i}"]`
            }))
          );
        }
      }), t = document.createElement("div");
      document.body.appendChild(t), o.mount(t);
    }
    const a = globalThis.__DtTooltipDirectiveAppInstance;
    d.directive("dt-tooltip", {
      beforeMount(o, t) {
        p(o, t);
      },
      updated(o, t) {
        v(t.value, t.oldValue) || p(o, t);
      },
      unmounted(o) {
        a.ctx.removeTooltip(o.getAttribute("data-dt-tooltip-id"));
      }
    });
    function p(o, t) {
      if (t.value === null || t.value === void 0) {
        const l = o.getAttribute("data-dt-tooltip-id");
        l && a.ctx.removeTooltip(l);
        return;
      }
      const i = o.getAttribute("data-dt-tooltip-id") || u();
      let e;
      if (typeof t.value == "string")
        e = {
          message: t.value,
          placement: t.arg || r
        };
      else if (typeof t.value == "object" && t.value !== null)
        e = {
          placement: t.arg || t.value.placement || r,
          ...t.value
        };
      else {
        console.error("DtTooltipDirective: binding value must be string, object, null or undefined");
        return;
      }
      Object.keys(t.modifiers).forEach((l) => {
        switch (l) {
          case "inverted":
            e.inverted = !0;
            break;
          case "no-delay":
            e.delay = !1;
            break;
          case "no-transition":
            e.transition = !1;
            break;
          default:
            T.includes(l) && (e.placement = l);
            break;
        }
      }), o.setAttribute("data-dt-tooltip-id", i), a.ctx.addOrUpdateTooltip(i, e);
    }
  }
};
export {
  k as DtTooltipDirective,
  k as default
};
//# sourceMappingURL=tooltip.js.map
